/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const folder = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 5.273c0-.603-.482-1.091-1.077-1.091h-7L5.631 2.436v0A1.072 1.072 0 0 0 4.769 2H2.077v0C1.482 2 1 2.488 1 3.09v9.82c0 .602.482 1.09 1.077 1.09h11.846v0c.595 0 1.077-.488 1.077-1.09V5.272Z"
    />
  </svg>
)
export default folder
